/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { css, cx } from "@panda/css";

import { CosmosVariableRichText, CosmosText, CosmosTextVariantEnum, CosmosRichText } from "../..";
import { CSSProperties } from "react";

export interface CosmosTitleProps {
	title?: CosmosVariableRichText | null;
	className?: string;
	style?: CSSProperties;
}

export const CosmosTitle = ({ title, className, style }: CosmosTitleProps): React.JSX.Element | null => {
	if (!title || (!title.text && !title.html)) {
		return null;
	}

	let titleEl = null;

	if (title?.text) {
		titleEl = (
			<CosmosText
				variant={title?.variant || CosmosTextVariantEnum.heading2XL}
				color={title?.color || "eds.text.primary"}
				as={title?.as || undefined}
				className={className}
				style={style}
			>
				{title?.text}
			</CosmosText>
		);
	}

	/**
	 * Detect html use by checking a closing html tag
	 */
	if (title?.html && title?.html.includes("</")) {
		//remove any leading line breaks
		const cleanHtml = title.html.replace(/^<br \/>/, "").replace(/^<br\/>/, "");
		titleEl = (
			<CosmosRichText
				{...title}
				variant={title?.variant || CosmosTextVariantEnum.heading2XL}
				color={title?.color || "eds.text.primary"}
				html={cleanHtml}
				className={cx(
					className,
					css({
						"&& p": {
							marginBlock: "0",
						},
						"&& em": {
							fontStyle: "italic",
							paddingInlineEnd: "eds.dimension.6",
						},
					}),
				)}
				style={style}
			/>
		);
	}

	return titleEl;
};
